import styled from "styled-components";
import {colors} from "../../../themes/colors";
import {sizes} from "../../../themes/sizes";
import {fontSize} from "../../../themes/css";

export const StyledInputField = styled.input`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 8px;
  gap: 8px;
  height: 40px;
  background-color: ${colors.general.white};
  border: 1px solid ${props => props.error ? colors.border.burntSienna : colors.border.silver};
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  ${fontSize(14)}
  line-height: 140%;
  text-align: left;
  color: ${colors.text.mineShaft};
  :focus {
    border-color: #333333;
    outline: 0;
  }
  opacity: ${props => props.disabled ? 0.6 : 1};
  @media only screen and ${sizes.max991} {
    padding: 2vw 1.6vw;
    gap: 1.6vw;
    height: 8vw;
  }
`;
